<div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <label class="block mb-1 font-medium">Grupo <span class="text-red-500">*</span></label>
        <p-select
          formControlName="groupId"
          [options]="groups"
          optionLabel="description"
          optionValue="id"
          placeholder="Selecione o grupo"
          class="w-full"
          styleClass="w-full"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('groupId') }"
        ></p-select>
        <small class="text-red-500" *ngIf="isFieldInvalid('groupId')">Grupo é obrigatório</small>
      </div>
      <div>
        <label class="block mb-1 font-medium">Descrição</label>
        <input
          pInputText
          formControlName="description"
          placeholder="Digite a descrição"
          class="w-full"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('description') }"
        />
        <small class="text-red-500" *ngIf="isFieldInvalid('description')">Descrição é obrigatória</small>
      </div>
    </div>
    <div>
      <button class="bg-orange-500 p-2 rounded-md text-white cursor-pointer" type="submit">Salvar</button>
    </div>
  </form>
</div>
